var InitialiseRegisterLogin = function () {
    var phoneNumber = $("#lblPhoneNumber").text();
    var email = $("#txtEmail").text();

    var resendEmailCooldownTimer = null;
    var resendEmailCooldownSeconds = 30;
    var cliVerificationCooldownTimer = null;
    var cliVerificationCooldownSeconds = 30;

    var pollingOnRunning = false;

    Heading.StoreCurrent();


    $("#btnYouCallUs").on("click", function () {
        Cli.InitialiseCliVerification(null, phoneNumber, Cli.CliVerificationType.inboundCallPlayPassword, function (data) {
            if (data.CliVerificationDto && data.CliVerificationDto.CliVerficationStatusId == Cli.CliVerification.Status.Requested &&
                data.CliVerificationDto.CliVerificationTypeId == Cli.CliVerificationType.inboundCallPlayPassword) {
                pollingOnRunning = true;
                ShowCliVerificationStatus(Cli.CliVerificationType.inboundCallPlayPassword, data.CliVerificationDto.CliVerficationStatusId, true);
                CheckCliVerification(phoneNumber);
            }
            else {
                // Error
                var cliVerficationStatusId = -1;
                if (data.CliVerificationDto) cliVerficationStatusId = data.CliVerificationDto.CliVerficationStatusId;
                ShowCliVerificationStatus(Cli.CliVerificationType.inboundCallPlayPassword, cliVerficationStatusId, false);
            }
        });
    });

    $("#btnWeCallYou").on("click", function () {
        Cli.InitialiseCliVerification(null, phoneNumber, Cli.CliVerificationType.outboundCallPlayPassword, function (data) {
            if (data.CliVerificationDto && data.CliVerificationDto.CliVerficationStatusId == Cli.CliVerification.Status.Requested &&
                data.CliVerificationDto.CliVerificationTypeId == Cli.CliVerificationType.outboundCallPlayPassword) {
                pollingOnRunning = true;
                ShowCliVerificationStatus(Cli.CliVerificationType.outboundCallPlayPassword, data.CliVerificationDto.CliVerficationStatusId, true);
                CheckCliVerification(phoneNumber);
            }
            else {
                // Error
                var cliVerficationStatusId = -1;
                if (data.CliVerificationDto) cliVerficationStatusId = data.CliVerificationDto.CliVerficationStatusId;
                ShowCliVerificationStatus(Cli.CliVerificationType.outboundCallPlayPassword, cliVerficationStatusId, false);
            }
        });
    });

    $("#btnResetLandline").on("click", function () {
        Cli.CancelCliVerification(null, phoneNumber, function (data) {
            if (data.CliVerificationDto) {
                if (data.CliVerificationDto.CliVerficationStatusId == Cli.CliVerification.Status.Cancelled) {
                    ResetCliVerificationLandLine();
                }
            }
            else {
                ResetCliVerificationLandLine();
            }
        });

    });

    $("#btnLoginRegisterNewV2").click(function () {
        if (Page_ClientValidate("AllValidators")) {
            var login = $("#txtMobile").val();
            var code = $("#txtCode").val();

            var data = { login: login, password: code };
            RegisterLoginStarted();
            $.ajax({
                data: JSON.stringify(data),
                type: "POST",
                contentType: "application/json; charset=utf-8",
                url: REGISTERLOGIN,
                dataType: "json",
                timeout: 60000,
                success: function (response, textStatus, jqXHR) {
                    if (typeof (fourdHandleAjaxSuccess) != 'undefined') {
                        fourdHandleAjaxSuccess(response, textStatus, jqXHR, this);
                    }
                    var responseData = GetNormalisedAjaxResponse(response);
                    var isLoggedIn = false;
                    if (responseData) {
                        if (responseData.IsAuthenticated) {
                            if (responseData.RedirectUrl != null && responseData.RedirectUrl.length > 0) {
                                // TODO - remove/update temp offer check logic
                                var currentURL = window.location;
                                var host = window.location.host;
                                var hostname = window.location.hostname;
                                var protocol = window.location.protocol;
                                var port = window.location.port;

                                var currentHostname = (port === 80 || port === 443) ? hostname : host;

                                window.location = protocol + '//' + currentHostname + responseData.RedirectUrl;
                            }
                            else {
                                //remove click event for login
                                $("#btnLoginRegisterNewV2").off("click");

                                //disable login controls
                                $("#btnLoginRegisterNewV2").addClass("aspNetDisabled").removeAttr("href");

                                isLoggedIn = true;
                                RegisterLoginSuccessful();
                            }
                        }
                        else {
                            //set login error message
                            $("#valPasswordAsync").attr("style", "");
                        }
                    }
                    RegisterLoginEnded(isLoggedIn);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (typeof (fourdHandleAjaxError) != 'undefined') {
                        fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                    }
                    //callback({}); //looks like a bxslider function
                    RegisterLoginEnded(false);
                }
            });

        }

    });

    $("#btnResendVerificationEmail").click(function () {
        if (Page_ClientValidate("AllValidators")) {

            var data = {};
            RegisterResendEmailStarted();
            $.ajax({
                data: JSON.stringify(data),
                type: "POST",
                contentType: "application/json; charset=utf-8",
                url: REGISTERRESENDEMAIL,
                dataType: "json",
                timeout: 60000,
                success: function (response) {
                    var responseData = GetNormalisedAjaxResponse(response);
                    var isLoggedIn = false;
                    if (responseData) {
                        if (responseData.RedirectUrl != null && responseData.RedirectUrl.length > 0) {
                            // TODO - remove/update temp offer check logic
                            var currentURL = window.location;
                            var host = window.location.host;
                            var hostname = window.location.hostname;
                            var protocol = window.location.protocol;
                            var port = window.location.port;

                            var currentHostname = (port === 80 || port === 443) ? hostname : host;

                            window.location = protocol + '//' + currentHostname + responseData.RedirectUrl;
                        }
                        else {
                            isLoggedIn = true;
                            RegisterResendEmailSuccessful();
                        }
                    }
                    RegisterResendEmailEnded(isLoggedIn);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (typeof (fourdHandleAjaxError) != 'undefined') {
                        fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                    }
                    //callback({}); //looks like a bxslider function
                    RegisterResendEmailEnded(false);
                }
            });

        }

    });

    $("#btnEditMobile").on("click", function () {
        var $txtMobile = $("#txtMobile");
        var isReadOnly = $txtMobile.prop("readonly");

        if (isReadOnly) {
            $txtMobile.prop("readonly", false).focus().select();
            $(this).find("use").attr("href", "#icon-check");
        } else {
            var newPhoneNumber = $txtMobile.val();
            if (!newPhoneNumber || newPhoneNumber.trim() === "") {
                $txtMobile.val(phoneNumber);
            } else {
                phoneNumber = newPhoneNumber;
            }
            $txtMobile.prop("readonly", true);
            $(this).find("use").attr("href", "#icon-edit");
        }
    });

    $("#btnResendCliVerification").on("click", function () {
        var newPhoneNumber = $("#txtMobile").val();

        if (!newPhoneNumber || newPhoneNumber.trim() === "") {
            return;
        }

        // Lock the field and commit the (possibly edited) number before resending
        $("#txtMobile").prop("readonly", true);
        $("#btnEditMobile").find("use").attr("href", "#icon-edit");

        StartCooldown("#btnResendCliVerification", "#cliVerificationCooldown", "#cliCooldownTimer");

        Cli.ResendCliVerification(null, newPhoneNumber, phoneNumber, Cli.CliVerificationType.smsSendPassword, function (data) {
            if (data.CliVerificationDto && data.CliVerificationDto.CliVerficationStatusId == Cli.CliVerification.Status.Requested &&
                data.CliVerificationDto.CliVerificationTypeId == Cli.CliVerificationType.outboundCallPlayPassword) {
                pollingOnRunning = true;
                ShowCliVerificationStatus(Cli.CliVerificationType.outboundCallPlayPassword, data.CliVerificationDto.CliVerficationStatusId);
                CheckCliVerification(phoneNumber);
            }
            else {
                // Error
                var cliVerficationStatusId = -1;
                if (data.CliVerificationDto) cliVerficationStatusId = data.CliVerificationDto.CliVerficationStatusId;
                ShowCliVerificationStatus(Cli.CliVerificationType.outboundCallPlayPassword, cliVerficationStatusId);
            }
        });
    });
}


function CheckCliVerification(cli) {

    Cli.GetCliVerification(null, cli, function (data) {
        if (pollingOnRunning) {
            if (data.CliVerificationDto) {
                var statusConfiguration = Cli.CliVerification.StatusConfiguration[Cli.CliVerification.StatusConfiguration.map(function (element) { return element.status; }).indexOf(data.CliVerificationDto.CliVerficationStatusId)];

                if (statusConfiguration && statusConfiguration != "") {
                    if (statusConfiguration.type == Cli.CliVerification.StatusType.waiting) {

                        if (data.CliVerificationDto.RequestCanBeCancelled) {
                            $("#divResetLandline").removeClass("hidden");
                        }
                        else {
                            $("#divResetLandline").addClass("hidden");
                        }
                        setTimeout(function () { CheckCliVerification(cli); }, Cli.ClientConfigurations.DefaultPollingTime);
                    }
                    else {
                        pollingOnRunning = false;
                        $("#divResetLandline").removeClass("hidden");
                    }
                    $("#iconStatus").attr("href", statusConfiguration.svgHref);
                    $("#spanStatusText").text(statusConfiguration.label);
                }
                else {
                    pollingOnRunning = false;
                    $("#divResetLandline").removeClass("hidden");
                }
            }
            else {
                pollingOnRunning = false;
                $("#divResetLandline").removeClass("hidden");
            }
        }
    });
}

function ResetCliVerificationLandLine() {
    pollingOnRunning = false;
    $("#btnWeCallYou").attr("disabled", false).show();
    $("#btnYouCallUs").attr("disabled", false).show();
    $("#liPassw0rd").addClass("hidden");
    $("#contentWeCallYou").addClass("hidden");
    $("#contentCallUs").addClass("hidden");
    $("#buttonLoginContent").addClass("hidden");
    $("#divStatus").addClass("hidden");
    $("#divResetLandline").addClass("hidden");
    $("#spanStatusText").text("Requested");
    $("#iconStatus").attr("href", "#icon-wait");
    Heading.Reset();
}

function RegisterLoginSuccessful() {
    UpdateRegistrationProgressStep(3);
    $("#loginForm").hide();
    $("#notLoggedInContent").addClass("hidden");
    $("#LoggedInContent").removeClass("hidden");
}

function RegisterLoginStarted() {
    $("#btnLoginRegisterNewV2").addClass("aspNetDisabled").attr("disabled", "disabled");
    $("#Loginspan").addClass("hidden");
    $("#loading").removeClass("hidden");
}

function RegisterLoginEnded(isLoggedIn) {
    if (isLoggedIn == false)
        $("#btnLoginRegisterNewV2").removeClass("aspNetDisabled").removeAttr("disabled");
    $("#loading").addClass("hidden");
    $("#Loginspan").removeClass("hidden");
}

// Resend email functions

function RegisterResendEmailStarted() {
    $("#btnResendVerificationEmail").addClass("aspNetDisabled").attr("disabled", "disabled");
    $("#resendEmailSpan").addClass("hidden");
    $("#resendEmailLoading").removeClass("hidden");
}

function RegisterResendEmailEnded(isLoggedIn) {
    StartCooldown("#btnResendVerificationEmail", "#resendEmailCooldown", "#cooldownTimer");

    $("#resendEmailLoading").addClass("hidden");
    $("#resendEmailSpan").removeClass("hidden");
}

function RegisterResendEmailSuccessful() {
    $("#notLoggedInContent").addClass("hidden");
    $("#emailResendContent").removeClass("hidden");
}

var Heading = {
    element: $("#notLoggedInContent")
    , html: null
    , htmlTemplate: "<h5></h5></br><p></p>"
    , StoreCurrent: function () {
        Heading.html = Heading.element.html();
    }
    , Set: function (h5, p) {
        Heading.element.html(Heading.htmlTemplate);
        Heading.element.children("h5").text(h5);
        Heading.element.children("p").text(p);
    }
    , Reset: function () {
        Heading.element.html(Heading.html);
    }
}

function ShowCliVerificationStatus(cliVerificationTypeId, cliVerficationStatusId, showVerifyingHeading) {
    $("#btnYouCallUs").hide();
    $("#btnWeCallYou").hide();
    $("#liPassw0rd").removeClass("hidden");
    $("#buttonLoginContent").removeClass("hidden");
    $("#divStatus").removeClass("hidden");

    if (cliVerificationTypeId == Cli.CliVerificationType.inboundCallPlayPassword) {
        $("#contentWeCallYou").addClass("hidden");
        $("#contentCallUs").removeClass("hidden");
    } else if (cliVerificationTypeId == Cli.CliVerificationType.outboundCallPlayPassword) {
        $("#contentWeCallYou").removeClass("hidden");
        $("#contentCallUs").addClass("hidden");
    }

    var statusConfiguration = Cli.CliVerification.StatusConfiguration[Cli.CliVerification.StatusConfiguration.map(function (element) { return element.status; }).indexOf(cliVerficationStatusId)];
    if (statusConfiguration && statusConfiguration != "") {
        $("#iconStatus").attr("href", statusConfiguration.svgHref);
        $("#spanStatusText").text(statusConfiguration.label);
    }

    if (showVerifyingHeading) {
        Heading.Set("Verifying your phone number", "Please now enter the password issued by our service to continue.");
    }
}

function UpdateRegistrationProgressStep(stepNumber) {
    const steps = $(".registration-progress .step");

    steps.removeClass("active");

    // Update each step based on stepNumber
    steps.each(function (index) {
        const currentStepNumber = index + 1; 
        const circle = $(this).find(".circle");
        const stepText = $(this).text().trim().replace(/\d+/, '').trim();

        if (currentStepNumber < stepNumber) {
            circle.addClass("checked").empty();
            circle.html('<svg width="16" height="16" class="check-icon"><use href="#icon-check-mark-progress"></use></svg>');
        } else if (currentStepNumber === stepNumber) {
            $(this).addClass("active");
            circle.addClass("checked").empty();
            circle.html('<svg width="16" height="16" class="check-icon"><use href="#icon-check-mark-progress"></use></svg>');
        } else {
            circle.removeClass("checked").text(currentStepNumber);
        }
    });
}

function StartCooldown(buttonSelector, cooldownDivSelector, timerSpanSelector, duration = 30) {
    const button = $(buttonSelector);
    const cooldownDiv = $(cooldownDivSelector);
    const timerSpan = $(timerSpanSelector);

    let remainingSeconds = duration;
    button.addClass("aspNetDisabled").attr("disabled", "disabled");
    cooldownDiv.removeClass("hidden");

    const timer = setInterval(function () {
        remainingSeconds--;

        if (remainingSeconds <= 0) {
            clearInterval(timer);
            button.removeClass("aspNetDisabled").removeAttr("disabled");
            cooldownDiv.addClass("hidden");
        } else {
            timerSpan.text(`Resend available in ${remainingSeconds}s`);
        }
    }, 1000);
}